module.exports = __webpack_public_path__ + "img/arrow_up_w.9edd210e.svg";